import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const BulkAchPaymentSchema = withDefaults({
  type: 'bulk-ach-payment',
  fields: [
    {
      kind: 'attribute',
      name: 'creditor',
    },
    {
      kind: 'attribute',
      name: 'totalAmount',
    },
    {
      kind: 'attribute',
      name: 'transactionCount',
    },
    {
      kind: 'attribute',
      name: 'rosterFileS3Path',
    },
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'settlementDate',
    },
    {
      kind: 'belongsTo',
      name: 'accountingPayment',
      type: 'accounting-payment',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'accountingTransactions',
      type: 'accounting-transaction',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default BulkAchPaymentSchema;
